import { render, staticRenderFns } from "./BaseWarningButton.vue?vue&type=template&id=2f060893&scoped=true"
import script from "./BaseWarningButton.vue?vue&type=script&lang=js"
export * from "./BaseWarningButton.vue?vue&type=script&lang=js"
import style0 from "./BaseWarningButton.vue?vue&type=style&index=0&id=2f060893&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f060893",
  null
  
)

export default component.exports